<div class="canvas-container">
    <div class="canvas-content">
        <div *ngIf="isLoading" class="loader-overlay">
            <mat-spinner diameter="60"></mat-spinner>
        </div>

        <!-- To show warning message if screen size is less than 9 inch -->
        <div class="mobile-warning-overlay" *ngIf="!isAdminRoute">
            <div class="warning-card">
                <mat-icon class="warning-icon">warning</mat-icon>
                <h2>Mobile Not<br />Supported</h2>
                <p [innerHTML]="'designer.mobileWarningMessage.message' | translate"></p>
                <app-button variant="hero" (click)="closeWarning()">Go To Home</app-button>
            </div>
        </div>

        <div class="top-section">
            <div class="left-section" *ngIf="!isViewMode && isNotFromProductDetail" (click)="$event.stopPropagation()">
                <action-button-container
                    [isEditMode]="isEditMode"
                    #actionContainer
                    [isEditted]="isEditted"
                    (resetIsEditted)="resetIsEditted($event)"
                    (loadStructureId)="getSelectedId($event)"
                    [structureData]="structureData"
                    [autoCaptureCanvasFunction]="autoCaptureCanvas.bind(this)"
                    (showSpinner)="showSpinner($event)"
                    (openOnBoardingDialog)="openOnBoardingDialog()"
                    [loadStructure]="loadStructure.bind(this)"
                >
                </action-button-container>

                <div *ngIf="stabilityResult && stabilityResult.reason" class="stability-message-container">
                    <p [ngClass]="{ stable: stabilityResult.valid, unstable: !stabilityResult!.valid }">
                        {{ stabilityResult.reason }}
                        @if (!stabilityResult.valid) {
                        <span class="view-preview" (click)="previewStability()"> Preview </span>
                        }
                    </p>
                </div>
            </div>

            <div class="count-info-section" *ngIf="!isViewMode && !isNotFromProductDetail">
                <div class="title-structure-info">
                    <div>
                        <p class="heading font-poppins">{{ titleForShapeInfo }}</p>
                    </div>

                    <div class="button-container">
                        <div class="button" matTooltip="Shape Count" (click)="showShapeCount()">S C</div>

                        <div class="button" matTooltip="Shape Highlight" (click)="showShapeHighlight()">S H</div>
                    </div>
                </div>

                @if (isCountInfoActive) {
                <div class="info-line">
                    <b>P</b>= Plane, <b>C</b> = Curved, <b>HP</b> = Half-Plane, <b>N</b> = Node, <b>H</b> = Hole,
                </div>
                } @if (isCountInfoActive) { @if (dataSource) {
                <div class="ouput-pattern-container">
                    @for (item of dataSource; let i = $index; track i) {
                    <div class="item-container" (click)="highlightShape(item.uuid)">
                        <div class="icon-name-section">
                            <span class="name-label">Name</span>
                            <span class="name font-poppins">{{ item.name }}</span>
                        </div>

                        <div class="face-section">
                            <span class="face-title">Face Pattern</span>
                            <span class="face-pattern">{{ item.facePattern }}</span>
                        </div>

                        <div class="count-section">
                            <span class="count-label">Count</span>
                            <span class="count font-poppins">
                                {{ item.count }}
                            </span>
                        </div>

                        <div class="shape-section">
                            <span class="shape-title">Shape</span>
                            <div class="shape-container">
                                <canvas #shape_canvas class="shape-canvas" [attr.data-index]="i"></canvas>
                            </div>
                        </div>
                    </div>
                    }
                </div>
                } } @else {
                <div class="shape-highlight-container">
                    @for (cell of availableCells; track cell) {
                    <mat-checkbox (change)="toggleSelectCells(cell)" [checked]="selectedCells.has(cell)">
                        {{ getLayerLabel(cell) }}
                    </mat-checkbox>
                    }
                </div>
                }
            </div>

            <div class="right-section" id="threeCanvas">
                <canvas #main_canvas class="main-canvas" (mousedown)="$event.preventDefault()"> </canvas>

                @if (!isViewMode && isNotFromProductDetail) {
                <div id="selectionBox"></div>
                }

                <compass-cube class="compass" [tourAnchor]="DesignerTourSteps.compass.anchorId!"></compass-cube>

                <div
                    class="capture-btn-container"
                    *ngIf="isViewMode && structureData?.status === structureStatus.Published"
                >
                    <button
                        mat-flat-button
                        class="capture-btn"
                        (click)="!isCaptureImageLoaded && captureImage()"
                        [disabled]="isDisabledCaptureBtn || isCaptureImageLoaded"
                    >
                        <ng-container *ngIf="!isCaptureImageLoaded; else loading"> Capture </ng-container>
                        <ng-template #loading>
                            <mat-progress-spinner diameter="20" mode="indeterminate" color="accent">
                            </mat-progress-spinner>
                        </ng-template>
                    </button>

                    <button
                        mat-flat-button
                        class="capture-btn"
                        *ngIf="!isGlb"
                        (click)="!isDisabledCapture360Btn && captureScene()"
                        [disabled]="isDisabledCapture360Btn"
                    >
                        Capture 360
                    </button>
                </div>

                <div class="zoom-action-container" *ngIf="!isViewMode && isNotFromProductDetail">
                    <div
                        *ngIf="isNotFromProductDetail"
                        matTooltip="{{ 'designer.tooltip.copy' | translate }}"
                        [tourAnchor]="DesignerTourSteps.copy.anchorId!"
                    >
                        <div
                            class="action-container"
                            [class.active-tour]="isTourStepActive"
                            [class.disabled]="!selectedMeshes.length || copyPasteService.copiedMeshes.length"
                            (click)="!isTourStepActive && clickCopyIcon()"
                        >
                            <mat-icon>content_copy</mat-icon>
                        </div>
                    </div>

                    <div
                        *ngIf="isNotFromProductDetail"
                        matTooltip="{{ 'designer.tooltip.paste' | translate }}"
                        [tourAnchor]="DesignerTourSteps.paste.anchorId!"
                    >
                        <div
                            class="action-container"
                            [class.active-tour]="isTourStepActive"
                            [class.disabled]="!copyPasteService.copiedMeshes.length"
                            (click)="!isTourStepActive && clickPasteIcon()"
                        >
                            <mat-icon>content_paste</mat-icon>
                        </div>
                    </div>

                    <div
                        *ngIf="isNotFromProductDetail"
                        [tourAnchor]="DesignerTourSteps.duplicate.anchorId!"
                        matTooltip="{{ 'designer.tooltip.duplicate' | translate }}"
                    >
                        <div
                            class="action-container"
                            [class.active-tour]="isTourStepActive"
                            [class.disabled]="!selectedMeshes.length || copyPasteService.copiedMeshes.length"
                            (click)="!isTourStepActive && clickDuplicateIcon()"
                        >
                            <mat-icon>library_add</mat-icon>
                        </div>
                    </div>

                    <div
                        *ngIf="isNotFromProductDetail"
                        matTooltip="{{ 'designer.tooltip.undo' | translate }}"
                        [tourAnchor]="DesignerTourSteps.undo.anchorId!"
                    >
                        <div
                            class="action-container"
                            [class.active-tour]="isTourStepActive"
                            [class.disabled]="copyPasteService.copiedMeshes.length || !canUndo"
                            (click)="!isTourStepActive && clickUndoIcon()"
                        >
                            <mat-icon>undo</mat-icon>
                        </div>
                    </div>

                    <div
                        *ngIf="isNotFromProductDetail"
                        matTooltip="{{ 'designer.tooltip.redo' | translate }}"
                        [tourAnchor]="DesignerTourSteps.redo.anchorId!"
                    >
                        <div
                            class="action-container"
                            [class.active-tour]="isTourStepActive"
                            [class.disabled]="copyPasteService.copiedMeshes.length || !canRedo"
                            (click)="!isTourStepActive && clickRedoIcon()"
                        >
                            <mat-icon>redo</mat-icon>
                        </div>
                    </div>

                    <div
                        *ngIf="isNotFromProductDetail"
                        matTooltip="{{ 'designer.tooltip.delete' | translate }}"
                        [tourAnchor]="DesignerTourSteps.deleteShape.anchorId!"
                    >
                        <div
                            class="action-container"
                            [class.active-tour]="isTourStepActive"
                            [class.disabled]="!selectedMeshes.length"
                            (click)="!isTourStepActive && clickDeleteIcon()"
                        >
                            <mat-icon>delete</mat-icon>
                        </div>
                    </div>

                    <div matTooltip="{{ 'designer.tooltip.zoomIn' | translate }}">
                        <div
                            class="action-container"
                            [class.active-tour]="isTourStepActive"
                            [tourAnchor]="DesignerTourSteps.zoomIn.anchorId!"
                            (click)="!isTourStepActive && zoom(zoomConfig.zoomIn)"
                        >
                            <mat-icon>zoom_in</mat-icon>
                        </div>
                    </div>

                    <div matTooltip="{{ 'designer.tooltip.zoomOut' | translate }}">
                        <div
                            class="action-container"
                            [class.active-tour]="isTourStepActive"
                            [tourAnchor]="DesignerTourSteps.zoomOut.anchorId!"
                            (click)="!isTourStepActive && zoom(zoomConfig.zoomOut)"
                        >
                            <mat-icon>zoom_out</mat-icon>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="bottom-section" *ngIf="!isViewMode && isNotFromProductDetail">
            <div class="action-section container">
                <div class="left-section">
                    <div class="total-block-container" [tourAnchor]="DesignerTourSteps.totalBlocks.anchorId!">
                        <p class="title">Total Blocks</p>
                        <p class="count">{{ meshes.length }}</p>
                    </div>

                    <div class="sepatator"></div>

                    <span
                        class="view-count"
                        [tourAnchor]="DesignerTourSteps.getCount.anchorId!"
                        (click)="getcountDialogBox()"
                        >View Count</span
                    >
                </div>

                <div class="right-section">
                    <button mat-flat-button class="btn" (click)="checkStability()">
                        <mat-icon>health_and_safety</mat-icon>
                        Check Stability
                    </button>
                    @for (btn of filteredSaveBtns; track btn) {
                    <button
                        mat-flat-button
                        class="btn"
                        (click)="!isStepTourActive && saveActions(btn.iconlabel)"
                        [tourAnchor]="btn.iconlabel"
                        [disabled]="isDisabled(btn)"
                    >
                        <mat-icon>{{ btn.iconlabel }}</mat-icon>
                        {{ btn.iconHint1 }}
                    </button>
                    }
                </div>
            </div>
        </div>
    </div>
</div>
